var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newdetail_wrap"},[_c('bsHeader',{attrs:{"title":_vm.data.title},on:{"backurl":function($event){return _vm.$router.back()}}}),_c('div',{staticClass:"ctn"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")]),_c('div',{staticClass:"contract_box",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }